import { BenefitRequest, BenefitState, GetBenefitsResponse, SetBenefitRequest } from "Application/models";
import { addBenefit, fetchBenefits, setBenefitOnPlan } from "Application/service";
import { create } from "zustand";
import { useCreatePlanStore } from "./usePlanStore";

export const useBenefitsStore = create<BenefitState >((set) => ({
  isLoading: false,
  isError: false,
  error: null,
  benefitsData: [],
  createBenefitsData: [],
  setBenefitsData: [],


  getBenefits: async () => {
    set({ isLoading: true });

    try {
      const response: GetBenefitsResponse = await fetchBenefits();

      set({isError: false, error: null, benefitsData: response });

    } catch (error) {
        set({ error: 'Failed to get countries', isError: true });
        throw error;
    } finally {
      set({ isLoading: false });
    }
  },

  createBenefit: async (createBenefitsData: BenefitRequest) => {
    set({ isLoading: true });

    try {
      await addBenefit(createBenefitsData);
      set({ isError: false, error: null });
      await useBenefitsStore.getState().getBenefits(); // Refresh the list after creating a plan

    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
      set({ error: errorMessage, isError: true });
    } finally {
      set({ isLoading: false });
    }
  },

  setBenefit: async (setBenefitsData: SetBenefitRequest, planId:any) => {
    set({ isLoading: true });

    try {
      await setBenefitOnPlan(setBenefitsData, planId);
      set({ isError: false, error: null });
      await useCreatePlanStore.getState().getSinglePlan(planId); // Refresh the list after creating a plan
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
      set({ error: errorMessage, isError: true });
    } finally {
      set({ isLoading: false });
    }
  }
}));